export default "/images/battery-charging.svg?794481196d05f5489db9884d76dc64a7";